import React from 'react'

import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import {MenuComponentProps} from "../const"
import {
    BUS_TREE_CHANGE,
    BUS_USER_CHANGE,
    SESSION_COMPANY_SETTINGS_CHANGED,
    SESSION_PROJECT_CHANGE,
    SESSION_PROJECT_USERS_CHANGED,
    SESSION_STARRED_CHANGED
} from "../../../../core/gd/bus/bus-event-type"
import NavigationMenu_ProjectsTree from "../projects/tree/projects-tree"
import NavigationMenu_WorkspaceSettings from "./settings/settings"
import MainMenu_WorkspaceCustomViews from "./custom-views/custom-views"
import NavigationMenuSection from "../../menu-items/section/section";
import MainMenu_Pins from "../../components/pins/pins";
import Workspace from "../../../../core/model2/space/workspaces/workspace";
import ErrorBoundary from "../../../../core/error-boundary";
import NavigationMenu_ProjectsTags from "../tags/tags"
import NavigationMenu_ProjectsTagsGroup from "../tags/tags-group"
import {TAGS_AS_TREE_GROUP} from "../tags/@const"
import NavigationMenu_SpacePreferences from "../../components/space-preferences/preferences";
import NavigationMenu_StarredProjects from "../../components/starred/starred-projects";
import ProjectSession from "../../../../core/model2/project/project-session";
import NavigationMenu_SectionProjectsTree from "../projects/tree/section-projects-tree"
import NavigationMenu_SectionPreferences from "../../components/section-preferences/preferences"
import Section from "../../../../core/model2/project/section"
import sectionPreferences_PopoverMenuOptions from "../../actions/section-preferences-menu-options";
import spacePreferences_PopoverMenuOptions from "../../actions/space-preferences-menu-options";
import ProjectWorkspaceProperties from "../../../../core/model2/project/properties/workspace/workspace-properties"
import {UIType} from "../../../ui/@const";

// const debug = "MainMenu_Workspace"
const debug = false

export default class MainMenu_WorkspaceContent extends React.Component<MenuComponentProps> {


    public localSettings        : NavigationMenu_ProjectsLocalSettings

    private workspace           : Workspace

    constructor(props:MenuComponentProps) {
        super(props)

        debug && console.log(debug, 'constructor', props.section)

        this.workspace      = props.section.space as Workspace
        this.localSettings  = new NavigationMenu_ProjectsLocalSettings(this.workspace.id)

    }

    componentDidMount() {
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged)
        gd.bus.subscribe(SESSION_COMPANY_SETTINGS_CHANGED, this, this.sessionDataChanged)
        gd.bus.subscribe(BUS_USER_CHANGE, this, this.sessionDataChanged)

        // need it on this level as we separate stars and all projects
        gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.sessionDataChanged)
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.sessionProjectChanged)
        gd.bus.subscribe(SESSION_PROJECT_USERS_CHANGED, this, this.sessionProjectUsersChanged)

    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    sessionDataChanged = () => {
        this.forceUpdate()
    }

    sessionProjectChanged = (projectId: ID) => {
        if (this.workspace.id === gd.session.projects.get(projectId)?.space.id) {
            this.forceUpdate()
        }
    }

    // is required to update on user is added/removed to/from project
    sessionProjectUsersChanged = () => {
        this.forceUpdate()
    }

    // async expandParentsForProject(projectId:ID) {
    //     return new Promise((resolve, reject) => {
    //         const parentProjectsIds = gd.session.projects.getAllParents(projectId).map((p:any)=>p.id)
    //         this.localSettings.expandedProjects = _.union(this.localSettings.expandedProjects, parentProjectsIds)
    //         this.localSettings.save()
    //
    //         this.forceUpdate(()=>{
    //             resolve(true)
    //         })
    //     })
    // }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {

        const rootTags = this.workspace.rootTags

        debug && console.log(debug, 'render()', this.workspace)

        const properties = this.workspace.project.properties as ProjectWorkspaceProperties
        const showResources = !properties.hideResourcesIfEmpty || this.workspace.resources.length > 0
        const showViews     = properties.showViewsGroup

        // rendered after the projects (before the "Everything" item)
        // no tree (no resources section) -> fall back to the tags section variant below
        const tagsGroup = TAGS_AS_TREE_GROUP && showResources && rootTags?.length > 0
            ? <NavigationMenu_ProjectsTagsGroup showAdd         = {true}
                                                parentProjectId = {this.workspace.project.id}
                                                tags            = {rootTags}/>
            : null

        return (
            <>

                <NavigationMenu_StarredProjects
                    systemName  = {this.workspace.id+"-starred"}
                    space       = {this.workspace}
                />

                {showResources &&
                    <NavigationMenuSection
                        name         = "Resources"
                        collapsible  = {true}
                        menuOptions  = {spacePreferences_PopoverMenuOptions(this.workspace, this.localSettings, this.reRender)}
                        controls     = {
                            <NavigationMenu_SpacePreferences
                                space           = {this.workspace}
                                localSettings   = {this.localSettings}
                                onReset         = {this.reRender}
                            />
                        }
                        systemName   = {this.workspace.id+"-resources"}
                        counter      = {this.workspace.menuResourcesCounter}
                    >

                        <NavigationMenu_ProjectsTree
                            space          = {this.workspace}
                            localSettings  = {this.localSettings}
                            endComponent   = {tagsGroup}
                        />
                    </NavigationMenuSection>
                }

                {_.map(this.workspace.sections, (projectSession: ProjectSession) => {

                    const section = new Section(projectSession)

                    const controls: React.ReactElement = <NavigationMenu_SectionPreferences section          = {section}
                                                                                            localSettings    = {this.localSettings}
                                                                                            onReset          = {this.reRender}/>
                    // Added for right click popup menu
                    const menuOptions = sectionPreferences_PopoverMenuOptions(section, this.localSettings, this.reRender)

                    return (
                        <NavigationMenuSection
                            key         = {projectSession.id+"-section"}
                            className   = 'm-b-20'
                            name        = {projectSession.name}
                            menuOptions = {menuOptions}
                            collapsible = {true}
                            controls    = {controls}
                            systemName  = {projectSession.id+"-sections"}
                            counter     = {projectSession.treeChildren.length}
                        >

                            <NavigationMenu_SectionProjectsTree
                                section         = {section}
                                localSettings   = {this.localSettings}
                            />
                        </NavigationMenuSection>
                    )
                })}

                {showViews &&
                    <MainMenu_WorkspaceCustomViews workspace = {this.workspace}/>}

                <ErrorBoundary>
                    <MainMenu_Pins space={this.workspace} />
                </ErrorBoundary>

                {!tagsGroup && rootTags?.length > 0 &&
                    <NavigationMenu_ProjectsTags showAdd         = {true}
                                                 parentProjectId = {this.workspace.project.id}
                                                 tags            = {rootTags}/>}

                {this.workspace.project.acl.hasFullAccess && gd.ui.type !== UIType.GOODDAY_MODERN &&
                    <NavigationMenu_WorkspaceSettings workspace={this.workspace} />
                }

            </>
        )
    }
}
